module.exports = __webpack_public_path__ + "img/slika35.d999ae0c.jpg";